import { CallablePageRef } from 'providers/page-ref';

export type ChangeWorkoutPageParams = {
  currentPlanReference: number;
  originalPlanReference: number;
};

export type ChangeWorkoutPageResult = {
  newPlanReference: number;
} | undefined;

export const IChangeWorkoutPage: CallablePageRef<ChangeWorkoutPageParams, ChangeWorkoutPageResult> = {
  pageName: 'ChangeWorkoutPage',
} as CallablePageRef<ChangeWorkoutPageParams, ChangeWorkoutPageResult>;
